import moment from "moment";
import 'moment/locale/es';
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const RRDocumento = ({doc, index, setIndexToEdit, setFormToShow, archivoDoc}) => {

    const handleChangeFecVec = () =>{
        setIndexToEdit(index);
        setFormToShow("vencimientoDoc");
    }

    return <div className="rrDocDiv">
        <div className="rrHeader">
            <h4 id="codDocLabel">{`${doc.codDocumento} - ${doc.codActivo}`}</h4>
            <h4 id="nameDocLabel">{`${doc.nameDocumento} - ${doc.nameActivo}`}</h4>
            <h4 className={(doc.tipoAlerta == 'VENC') ? 'alertaVENC' : (doc.tipoAlerta == 'PorVENC') ? 'alertaPorVENC' : ''} id="h4Alerta">{(doc.tipoAlerta == 'VENC') ? 'Vencido' : (doc.tipoAlerta == 'PorVENC') ? 'Por Vencer' : ''}</h4>
            {archivoDoc?.url && <a href={archivoDoc.url} download target="_blank" rel="noopener noreferrer" title="Descargar archivo" style={{cursor:'pointer'}}>
                <label style={{cursor:'pointer'}}>Descargar archivo adjunto</label>
                <FontAwesomeIcon icon={faDownload} className="downloadDocFileIcon"/>
            </a>}
        </div>
        <div className="rrBody">
            <label>Alerta Anticipo: {doc.alertaAnticipo}</label>
            <label>Fecha Vencimiento: {moment.utc(doc.fecha).locale('es').format('D [de] MMMM [de] YYYY')}</label>
            <label>Texto Adicional: {doc.textAdic}</label>
        </div>
        <div className="rrButtonsDiv">
            <button onClick={handleChangeFecVec}>Modificar Fecha de Vencimiento</button>
        </div>
    </div>

}

export default RRDocumento;